import style from "./style.scss";
import { mergeClasses } from "../helpers";

const NoMargin = ({ children }) => (
  <div class={mergeClasses([style.noMargin])}>{children}</div>
);

export default NoMargin;
